import { GrowthBook } from '@growthbook/growthbook';
import { detectDevice } from './detect-device.js';

async function growthbookInitialiseClient(growthbookContext, deviceId, { growthbookAttributes = {} } = {}) {
    const growthbook = new GrowthBook(growthbookContext);
    const platform = detectDevice(navigator.userAgent);
    const attributes = {
        ...growthbookAttributes.channel,
        ...growthbookAttributes.user,
        growthbook_id: deviceId,
        platform,
    };
    growthbook.setAttributes(attributes);
    // give GrowthBook two seconds to initialise. In case of error it does not throw
    // but instead just sets all features etc to null
    // https://docs.growthbook.io/lib/js#error-handling
    await growthbook.init({ timeout: 2000 });
    return growthbook;
}

export { growthbookInitialiseClient };
//# sourceMappingURL=growthbook-client.js.map
